import { CanActivateFn } from '@angular/router';

export const ExternalRedirectGuard: CanActivateFn = (route, state) => {
  const originHost = window.location.origin; // gives protocol + host + port
  let host;
  if(originHost.includes('localhost:3200')){
    host = 'http://localhost:4200';
  }else if(originHost.includes('dev-manufacturer')){
    host = 'http://dev-console.freightfox.ai';
  }else if(originHost.includes('console')){
    host = 'http://console.freightfox.ai';
  }
  const redirectUrl = `${host}${state.url}`;
  window.location.href = redirectUrl;

  return false;
};
